var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHalfStar = function SvgHalfStar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 576"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M288 391.2V.2l-63.5 195.4H18.9l166.3 120.8L121.7 512z"
  })));
};
export default SvgHalfStar;